import {
  STATUS_FILTER,
} from "../../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");

export const basicFormData = () => ({
  inputData: {
    name: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "oem_master",
    schema: schema,
    inputData: {
      name: "",
      created_by: "",
      updated_by: "",
      is_active: true,
    },
    moduleWhereCondition: {
      is_active: true,
    },
    relations: [
      {
        module: "oem_masters_masters",
        moduleAs: "subcontractor",
        isModuleWhereConditionRequired: true,
      },
      {
        module: "role_documents",
        moduleAs: "role_documents",
        isModuleWhereConditionRequired: true,
      },
    ],
  };
  const deleteRelation = [
    {
      modelName: "role_masters",
      moduleAs: "subcontractor",
      foreignKey: "subcontractor_id",
    },
    {
      modelName: "role_documents",
      moduleAs: "role_documents",
      foreignKey: "role_id",
    },
  ];

  const navigatePage = { back: "/oem-list" };

  const headerName = "OEM";

  const validationType = "OEMCreate";
  const createEndpoint = "/updaterelationaldata";
  const updateEndpoint = "/updaterelationaldata";
  const getEndpoint = "/getRecords";

  const dependentDropdownData = [
    {
      module_name: "oem_master",
      initialPayload: { modelName: "oem_master" },
      isOtherDependentOnThis: false,
      patchFieldName: "name",
      dropdownDataValue: "role_id",
      endPoint: "/getRecords",
    },
  ];
  const multiModuleFormModules = [
    {
      moduleName: "role_documents",
      formFields: [
        {
          label: "Document Name",
          name: "document",
          type: "text",
          placeholder: "Document name",
          asterisk: true,
        },

        {
          label: "File",
          name: "file",
          type: "file",
          placeholder: "Document",
        },
      ],
    },
    {
      moduleName: "subcontractor",
      formFields: [
        {
          label: "Role Name",
          name: "role_name",
          type: "text",
          placeholder: "Role name",
        },
      ],
    },
  ];

  const multiModuleNames = multiModuleFormModules.map(
    (module) => module.moduleName
  );

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    multiModuleNames,
    multiModuleFormModules,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    deleteRelation,
  };
};

export const listPageData = (type) => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "oem_master",
    schema: schema,
  };

  const columnData = [
    { label: "Sr. No", value: "index" },
    { label: "OEM Name", value: "name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/oem-create",
    edit: "/oem-create",
    view: "/oem-view",
  };

  const searchfields = ["name"];

  const headerName = "OEM";
  const endpoint = "/getRecords";
  const exportFileName = "OEMData.xlsx";

  const filterConfig = [STATUS_FILTER];

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "oem_master",
  schema: schema,
  whereCondition: {
    role_type: { in: [1] },
  },

  // relations: [
  //     {
  //         module: "role_masters",
  //         moduleAs: "createdBy",
  //     },
  //     {
  //         module: "role_masters",
  //         moduleAs: "updatedBy",
  //     },
  //     {
  //         module: "role_masters",
  //         moduleAs: "subcontractor",
  //     },
  //     {
  //         module: "role_masters",
  //         moduleAs: "role_masters",
  //     },
  //     {
  //         module: "company_masters",
  //         moduleAs: "company_masters",
  //     },
  // ],
  pagination: { page: 1, pageSize: 10000 },
};
